import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Observable } from 'rxjs/Observable';
import { SendMoneyDetail, SendMoneySteps } from '../../models/sendmoney/sendmoney';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { storedetailmodalcomponent } from '../../sendMoney/_modalpopup/store-popup/store-popup.component';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { enumStatusCodeList, PaymentType } from '../../sharedcomponents/_common/constants/app.constants';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { Ng2DeviceService } from "ng2-device-detector";
@Component({
  selector: 'app-payatstore',
  templateUrl: './payatstore.component.html',
  styleUrls: ['./payatstore.component.css'],
  providers: [AlertService, CountryService]
})
export class PayatstoreComponent implements OnInit {
  PageFlow: any = {};
  sendMoneyDetail: SendMoneyDetail;
  storeCollection: any;
  model: any = {};
  loading = false;
  mapOptions: any;
  userGioLocation: UserGioLocation;
  constructor(
    private router: Router,
    private geoloc: geolocation,
    private alertService: AlertService,
    private sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    public translate: TranslateService,
    private vcRef: ViewContainerRef,
    private deviceService: Ng2DeviceService,
    private modal: Modal
  ) {
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    if (this.sendMoneyDetail.pickupTypeDetails.countryName == undefined || this.sendMoneyDetail.pickupTypeDetails.countryName == '') {
      if (this.PageFlow.Value == 'repeatorder') {
        if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
          this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(['/repeatorderlist']);
        }
      } else {
        this.router.navigate(['/dashboard']);
      }
      return;
    } else {
      this.userGioLocation = new UserGioLocation();
      this.geoloc.getserGioLocation().subscribe(data => {
        this.userGioLocation = data;
        this.mapOptions = {
          center: { lat: parseFloat(this.userGioLocation.latitude), lng: parseFloat(this.userGioLocation.longitude) },
          zoom: 10,
          mapTypeId: 'roadmap',
          tilt: 45
        };
        });
      }
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.sendMoneyDetail.isData == true && this.PageFlow.Value == 'sendmoney') {
      let _self=this;
      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        modalData.Title = this.translate.instant('Common_lblConfirm');
        modalData.Message = this.translate.instant('SendMoney_navigateConfirmDesc');
        this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(data => {
            console.log('Observer got a next value: ' + data);
            if (modalData.next == 'yes') {
              let DeviceDetail = _self.deviceService.getDeviceInfo();
              (<any>window).firebase
                .analytics()
                .logEvent("UnfinishedTransaction", {
                  Screen: "PaymentType",
                  Platform: AppSettings.Platform,
                  Browser: DeviceDetail.browser,
                  OSVersion: DeviceDetail.os_version,
                  AppVersion: AppSettings.Appversion
                });
              observer.next(true);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
          });
        });
      });
    }
    return true;
  }
  ngOnInit() {
    this.loadStoresMap();
  }

  loadStoresMap() {
    const _self = this;
    const IsPayatstore = true;
    this.utilityServ.busy = this.geoloc.getGioLocation().subscribe(data => {
      const userGioLocation: any = data;
      this.geoloc.setserGioLocation(data)
      this.utilityServ.busy = this.sendMoneyService.loadStoresInMap(IsPayatstore, userGioLocation).subscribe(
        data => {
          const resJSON = data;
          if (resJSON.Envelope.Body.StoresResponse.StatusCode == enumStatusCodeList.SUCCESS) {
            _self.loading = false;
            let tempStoreCollection: any = _self.utilityServ.getArray(resJSON.Envelope.Body.StoresResponse.Stores.StoreDetail);
            if (_self.sendMoneyDetail.currentCartDetail.CustmerPaymentMethod == PaymentType.PayAtStore) {
              _self.storeCollection = tempStoreCollection.filter(function(ele) {
                return _self.utilityServ.getObjectText(ele.StoreID) == _self.sendMoneyDetail.currentCartDetail.StoreId;
              });
            } else {
              this.storeCollection = tempStoreCollection;
            }

            this.showRandomMarkers(this.storeCollection);
            //resJSON.Envelope.Body.GetStoreLocatorsResponse.GetStoreLocatorsResult.Stores.StoreDetail;
          } else {
            this.loading = false;
            this.alertService.error(resJSON.Envelope.Body.StoresResponse.StatusMessage);
          }
        },
        error => {
          console.log('Observer got a next value: ' + error);
        }
      );
    });
  }

  positions = [];

  showRandomMarkers(markerCollection) {
    this.positions = [];
    for (let markerCount = 0; markerCount < markerCollection.length; markerCount++) {
      this.positions.push([this.utilityServ.getObjectText(markerCollection[markerCount].Address.Latitude), this.utilityServ.getObjectText(markerCollection[markerCount].Address.Longitude)]);
    }
  }
  onMarkerInit(marker) {
    console.log('marker', marker);
  }

  openstore(modalData) {
    // const modalData = this.storeCollection;
    let self = this;

    return this.modal.open(storedetailmodalcomponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        console.log('Observer got a next value: ' + data);
        if (modalData.next == 'continue') {
          if (self.PageFlow.Value == 'repeatorder') {
            if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
              self.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
            } else {
              self.router.navigate(['/repeatorderlist']);
            }
          } else {
            self.sendMoneyService.setModalPopup(SendMoneySteps.Summary);
            self.router.navigate(['/sendmoney']);
          }
        } else if (modalData.next == 'moreInfo') {
          self.router.navigate(['/storedetails']);
        }
      });
    });
  }
  updateDiv() {}
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_payatstore/payatstore.component.ts